import {
    homePageRoute,
    showfloorPageRoute,
    programPageRoute,
    conferencePageRoute,
    sponsorsPageRoute,
    couponsPageRoute,
    pressMediaPageRoute,
    businessAreaPageRoute,
    iframeTestPageRoute,
    exhibitorStartupPageRoute,
    helpPageRoute,
    collectionOverviewRoute,
    hallplanOverviewRoute,
    mySchedulePageRoute,
    newsPageRoute
} from "../RoutePaths"
import {
    IconHome,
    IconOrganization,
    IconProgram,
    IconMeetings,
    IconSponsor,
    IconCoupon,
    IconMyFair,
    IconPressMedia,
    IconBusinessArea,
    IconIframeTest,
    IconExhibitorStartup,
    IconNavigationHelp,
    IconCollections,
    IconHallplan,
    IconMySchedule,
    IconOrganizerNews
} from "../../ui/Icons"
import branding from "../../branding/branding"

//side icon bar enumeration for IDs
export enum SideIconBarItemIds {
    "LOBBY" = "LOBBY",
    "MY_FAVOURITES" = "MY_FAVOURITES",
    "MY_SCHEDULE" = "MY_SCHEDULE",
    "SHOWFLOOR" = "SHOWFLOOR",
    "PROGRAM" = "PROGRAM",
    "VIRTUAL_CAFES" = "VIRTUAL_CAFES",
    "PARTNERS_SPONSORS" = "PARTNERS_SPONSORS",
    "NEWS" = "NEWS",
    "GOODIE_BAG" = "GOODIE_BAG",
    "PRESS_MEDIA" = "PRESS_MEDIA",
    "BUSINESS_AREA" = "BUSINESS_AREA",
    "IFRAME_TEST" = "IFRAME_TEST",
    "STARTUP" = "STARTUP",
    "HELP" = "HELP",
    "COLLECTIONS" = "COLLECTIONS",
    "HALLPLAN" = "HALLPLAN"
}

//side icon bar enumeration for keys
export enum SideIconBarItemKeys {
    "home" = "home",
    "organization" = "organization",
    "news" = "news",
    "program" = "program",
    "meetings" = "meetings",
    "collections" = "collections",
    "hallplan" = "hallplan",
    "sponsor" = "sponsor",
    "coupon" = "coupon",
    "press_media" = "press_media",
    "business" = "business",
    "iframe_test" = "iframe_test",
    "startup" = "startup",
    "help" = "help",
    "my_schedule" = "my_schedule"
}

export function checkActiveItem(
    key: string,
    lobbyCheck: boolean,
    checkString: string,
    currentItem: string,
    myToggle: string,
    isMobile?: boolean
): boolean {
    let toggle = myToggle

    if (lobbyCheck) {
        if (isMobile === false && !branding.sideIconBar.sideIconBarItemsOrder.includes(SideIconBarItemIds.MY_FAVOURITES)) {
            return currentItem === key && (toggle === SideIconBarItemIds.LOBBY || toggle === "MY_FAIR")
        }
        return currentItem === key && toggle === checkString
    }
    return currentItem === key
}

interface SideBarConfigType {
    id: SideIconBarItemIds
    key: SideIconBarItemKeys
    path: string
    icon: any
    title: string
    shortName: string
    lobbyCheck: boolean
    checkString?: string
    isExternalLink?: boolean
    customUrl?: string
    hideOnMobile?: boolean
}

//method which provides side icon bar items with configuration
export const SideBarConfig = (
    currentItem: string,
    isMeetingPage: boolean,
    myToggle: string,
    isNavOpen: boolean,
    isMobile?: boolean
): Array<SideBarConfigType> => {
    function isActiveItem(key: string, lobbyCheck?: boolean, checkString?: string): boolean {
        return checkActiveItem(key, lobbyCheck ?? false, checkString ?? "", currentItem, myToggle, isMobile)
    }

    function getIconFill(active: boolean): string {
        let color: string = isMeetingPage
            ? branding.sideIconBar.sideIconColorLight
            : isNavOpen
            ? branding.activeIconColor
            : branding.navBarActiveIconColor
        // (isNavOpen && active ? branding.navBarActiveIconColor : (!isNavOpen && active ? branding.navBarActiveIconColor : branding.navBarActiveIconColor))

        if (!active && !isMobile) {
            color = branding.sideIconBar.inactiveItemColor
        }

        return color
    }

    function getIconStroke(active: boolean): string {
        let color: string =
            isMeetingPage && !active
                ? branding.sideIconBar.sideIconColorLight
                : !isNavOpen && active
                ? branding.sideIconBar.drawerClosedButtonSelectBackgroundColor
                : branding.sideIconBar.sideIconColorLight
        return color
    }

    return [
        {
            id: SideIconBarItemIds.LOBBY,
            key: SideIconBarItemKeys.home,
            path: homePageRoute,
            icon: IconHome({ fill: getIconFill(isActiveItem(SideIconBarItemKeys.home, true, SideIconBarItemIds.LOBBY)) }),
            title: branding.sideIconBar.lobbyMenuText,
            shortName: branding.receptionPage.navbarHomePageShortName,
            lobbyCheck: true,
            checkString: SideIconBarItemIds.LOBBY
        },
        {
            id: SideIconBarItemIds.MY_FAVOURITES,
            key: SideIconBarItemKeys.home,
            path: homePageRoute,
            icon: IconMyFair({
                fill: getIconFill(isActiveItem(SideIconBarItemKeys.home, true, "MY_FAIR"))
            }),
            title: branding.receptionPage.receptionPageMyHeaderTitle,
            shortName: branding.receptionPage.navbarMyPageShortName,
            lobbyCheck: true,
            checkString: "MY_FAIR"
        },
        {
            id: SideIconBarItemIds.MY_SCHEDULE,
            key: SideIconBarItemKeys.my_schedule,
            path: mySchedulePageRoute,
            icon: IconMySchedule({
                fill: getIconFill(isActiveItem(SideIconBarItemKeys.my_schedule)),
                stroke: getIconStroke(isActiveItem(SideIconBarItemKeys.my_schedule)),
                width: "22px",
                height: "22px"
            }),
            title: branding.receptionPage.mySchedule,
            shortName: branding.receptionPage.mySchedule,
            lobbyCheck: false
        },
        {
            id: SideIconBarItemIds.SHOWFLOOR,
            key: SideIconBarItemKeys.organization,
            path: showfloorPageRoute,
            icon: IconOrganization({
                fill: getIconFill(isActiveItem(SideIconBarItemKeys.organization))
            }),
            title: branding.sideIconBar.showfloorMenuText,
            shortName: branding.receptionPage.navbarShowfloorPageShortName,
            lobbyCheck: false
        },
        {
            id: SideIconBarItemIds.NEWS,
            key: SideIconBarItemKeys.news,
            path: newsPageRoute,
            icon: IconOrganizerNews({
                fill: getIconFill(isActiveItem(SideIconBarItemKeys.news))
            }),
            title: branding.sideIconBar.newsMenuText,
            shortName: branding.receptionPage.navbarNewsPageShortName,
            lobbyCheck: false
        },
        {
            id: SideIconBarItemIds.PROGRAM,
            key: SideIconBarItemKeys.program,
            path: programPageRoute,
            icon: IconProgram({
                fill: getIconFill(isActiveItem(SideIconBarItemKeys.program)),
                stroke: getIconStroke(isActiveItem(SideIconBarItemKeys.program)),
                width: "22px",
                height: "22px"
            }),
            title: branding.sideIconBar.programMenuText,
            shortName: branding.receptionPage.navbarProgramPageShortName,
            lobbyCheck: false
        },
        {
            id: SideIconBarItemIds.VIRTUAL_CAFES,
            key: SideIconBarItemKeys.meetings,
            path: conferencePageRoute,
            icon: IconMeetings({
                fill: getIconFill(isActiveItem(SideIconBarItemKeys.meetings)),
                stroke: getIconStroke(isActiveItem(SideIconBarItemKeys.meetings))
            }),
            title: branding.sideIconBar.virtualcafeMenuText,
            shortName: branding.receptionPage.navbarVirtualCafePageShortName,
            lobbyCheck: false,
            hideOnMobile: true
        },
        {
            id: SideIconBarItemIds.COLLECTIONS,
            key: SideIconBarItemKeys.collections,
            path: collectionOverviewRoute,
            icon: IconCollections({
                fill: getIconFill(isActiveItem(SideIconBarItemKeys.collections)),
                stroke: getIconStroke(isActiveItem(SideIconBarItemKeys.collections))
            }),
            title: branding.sideIconBar.collectionsMenuText,
            shortName: branding.receptionPage.navbarCollectionsPageShortName,
            lobbyCheck: false
        },
        {
            id: SideIconBarItemIds.HALLPLAN,
            key: SideIconBarItemKeys.hallplan,
            path: hallplanOverviewRoute,
            icon: IconHallplan({
                fill: getIconFill(isActiveItem(SideIconBarItemKeys.hallplan)),
                stroke: getIconStroke(isActiveItem(SideIconBarItemKeys.hallplan)),
                width: "22px",
                height: "22px"
            }),
            title: branding.sideIconBar.hallplanMenuText,
            shortName: branding.receptionPage.navbarHallplanPageShortName,
            lobbyCheck: false
        },
        {
            id: SideIconBarItemIds.PARTNERS_SPONSORS,
            key: SideIconBarItemKeys.sponsor,
            path: sponsorsPageRoute,
            icon: IconSponsor({ fill: getIconFill(isActiveItem(SideIconBarItemKeys.sponsor)) }),
            title: branding.sideIconBar.mediapartnersMenuText,
            shortName: branding.receptionPage.navbarPartnersSponsorsPageShortName,
            lobbyCheck: false
        },
        {
            id: SideIconBarItemIds.GOODIE_BAG,
            key: SideIconBarItemKeys.coupon,
            path: couponsPageRoute,
            icon: IconCoupon({ fill: getIconFill(isActiveItem(SideIconBarItemKeys.coupon)) }),
            title: branding.sideIconBar.goodiebagMenuText,
            shortName: branding.receptionPage.navbarGoodieBagPageShortName,
            lobbyCheck: false
        },
        {
            id: SideIconBarItemIds.PRESS_MEDIA,
            key: SideIconBarItemKeys.press_media,
            path: pressMediaPageRoute,
            icon: IconPressMedia({ fill: getIconFill(isActiveItem(SideIconBarItemKeys.press_media)) }),
            title: branding.sideIconBar.pressMediaMenuText,
            shortName: branding.receptionPage.navbarPressMediaPageShortName,
            lobbyCheck: false,
            hideOnMobile: true
        },
        {
            id: SideIconBarItemIds.BUSINESS_AREA,
            key: SideIconBarItemKeys.business,
            path: businessAreaPageRoute,
            icon: IconBusinessArea({ fill: getIconFill(isActiveItem(SideIconBarItemKeys.business)) }),
            title: branding.sideIconBar.businessAreaMenuText,
            shortName: branding.receptionPage.navbarLeadFinderPageShortName,
            lobbyCheck: false
        },
        {
            id: SideIconBarItemIds.IFRAME_TEST,
            key: SideIconBarItemKeys.iframe_test,
            path: iframeTestPageRoute,
            icon: IconIframeTest({ fill: getIconFill(isActiveItem(SideIconBarItemKeys.iframe_test)) }),
            title: branding.sideIconBar.iFrameTestMenuText,
            shortName: branding.receptionPage.navbarIFramePageShortName,
            lobbyCheck: false
        },
        {
            id: SideIconBarItemIds.STARTUP,
            key: SideIconBarItemKeys.startup,
            path: exhibitorStartupPageRoute,
            icon: IconExhibitorStartup({ fill: getIconFill(isActiveItem(SideIconBarItemKeys.startup)) }),
            title: branding.sideIconBar.exhibitorStartupMenuText,
            shortName: branding.receptionPage.navbarStartupPageShortName,
            lobbyCheck: false
        },
        {
            id: SideIconBarItemIds.HELP,
            key: SideIconBarItemKeys.help,
            path: helpPageRoute,
            icon: IconNavigationHelp({ fill: getIconFill(isActiveItem(SideIconBarItemKeys.help)) }),
            title: branding.sideIconBar.helpItem.title,
            shortName: branding.receptionPage.navbarHelpPageShortName,
            lobbyCheck: false,
            isExternalLink: branding.sideIconBar.helpItem.isExternalLink,
            customUrl: branding.sideIconBar.helpItem.externalLink ?? branding.sideIconBar.helpItem.link
        }
    ]
}
